import Select from "../../../main/Select";

function LanguageFormSelectView({
  options,
  value,
  onChange,
  disabled,
  nullable,
}) {
  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
      nullable={nullable}
    />
  );
}

export default LanguageFormSelectView;
